import Web3 from 'web3';
export const useWeb3 = (rpcUrl) => {
    const web3 = new Web3(rpcUrl);
    return web3;
};
